


























































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import MainComponent from "@/components/layout/MainComponent.vue";
import SidebarComponent from "@/components/layout/SidebarComponent.vue";
import ContentComponent from "@/components/layout/ContentComponent.vue";
import SidebarContentHeaderComponent from "@/components/layout/SidebarContentHeaderComponent.vue";
import MenubarComponent from "@/components/layout/MenubarComponent.vue";
import FormBoxComponent from "@/components/common/form/FormBoxComponent.vue";
import FormRowComponent from "@/components/common/form/FormRowComponent.vue";
import RequiredMarkComponent from "@/components/common/parts/RequiredMarkComponent.vue";
import InputTextComponent from "@/components/common/parts/InputTextComponent.vue";
import SelectComponent from "@/components/common/parts/SelectComponent.vue";
import CalendarComponent from "@/components/common/parts/CalendarComponent.vue";
import CheckboxComponent from "@/components/common/parts/CheckboxComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import ConfirmDialogComponent from "@/components/common/parts/ConfirmDialogComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import { getCompanyApi } from "@/typescript/api_client/emesh_api/master/company_api";
import { getStoregroupApi } from "@/typescript/api_client/emesh_api/stores/storegroup_api";
import { getUsersgroupsApi } from "@/typescript/api_client/emesh_api/users/usergroups_api";
import { getPrefectureApi } from "@/typescript/api_client/emesh_api/master/prefecture_api";
import { getStoresApi } from "@/typescript/api_client/emesh_api/stores/stores_api";
import { registerStoreApi } from "@/typescript/api_client/emesh_api/stores/stores_register_api";
import { storeMenus } from "@/config/store_menus";
import { getRoutePath } from "@/router/routes";
import { Moment } from "@/typescript/lib/common/moment";
import {
  GetStoregroupResponse,
  GetStoresResponse
} from "@/typescript/api_client/emesh_api/stores/types";
import { GetUsergroupResponse } from "@/typescript/api_client/emesh_api/users/types";
import {
  GetPrefectureResponse,
  GetCompanyResponse
} from "@/typescript/api_client/emesh_api/master/types";
export {
  GetCompanyResponse,
  GetStoregroupResponse,
  GetPrefectureResponse,
  GetUsergroupResponse,
  GetStoresResponse
};

const moment = new Moment("YYYY/MM/DD");
const today = moment.getFormatDate();

@Component({
  components: {
    HeaderComponent,
    MainComponent,
    SidebarComponent,
    ContentComponent,
    SidebarContentHeaderComponent,
    MenubarComponent,
    FormBoxComponent,
    FormRowComponent,
    RequiredMarkComponent,
    InputTextComponent,
    SelectComponent,
    CalendarComponent,
    CheckboxComponent,
    ButtonComponent,
    ConfirmDialogComponent,
    FooterComponent
  }
})
export default class StoreInfosEditPage extends Vue {
  isRemoved: boolean = false;
  selectWidth: string = "200px";
  selectLargeWidth: string = "440px";
  corp: { [s: string]: any } = { value: "", errors: [] };
  shopId: { [s: string]: any } = { value: "", errors: [] };
  shopNumber: { [s: string]: any } = { value: "", errors: [] };
  shopGroup: { [s: string]: any } = { value: "", errors: [] };
  shopName: { [s: string]: any } = { value: "", errors: [] };
  pref: { [s: string]: any } = { value: "", errors: [] };
  address: { [s: string]: any } = { value: "", errors: [] };
  tel: { [s: string]: any } = { value: "", errors: [] };
  userGroups: { [s: string]: any }[] = [{ value: "", errors: [] }];
  openDate: { [s: string]: any } = { value: today, errors: [] };
  closeDate: { [s: string]: any } = { value: today, errors: [] };
  gateway: { [s: string]: any } = { value: "", errors: [] };
  hasError: boolean = false;
  errorMessage: string = "入力に誤りがあります";
  errorMessages: { [s: string]: string } = {
    required_select: "選択してください",
    required_input: "入力してください",
    number: "数字を入力してください",
    format: "フォーマットが違います",
    alphanumeric: "半角英数を入力してください",
    store_no_unique: "この店舗番号は既に使用されています",
    store_name_unique: "この店舗名は既に使用されています",
    gateway_unique: "このゲートウェイ情報は既に使用されています"
  };
  //マスターデータ
  companies: GetCompanyResponse[] = [];
  storegroups: GetStoregroupResponse[] = [];
  prefectures: GetPrefectureResponse[] = [];
  allUserGroups: GetUsergroupResponse[] = [];
  // 確認モーダル
  title: string = "設定を保存しますか？";
  // 2021.09.27 不要なメッセージなので表示されないように修正
  body: string = "";
  //  "撤去作業予定にチェックが入っています。\nこの項目は取り消しできません。";
  display: boolean = false;
  isConfirmDialogOpen: boolean = false;
  workingState: number | null = null;

  get workingStateName() {
    if (this.workingState === null) return "稼働情報なし";
    else if (this.workingState === 0) return "初回通信待ち";
    else if (this.workingState === 1) return "稼働中";
    else if (this.workingState === 2) return "撤去";
    return "";
  }

  get isDisabledOpenDate() {
    if (this.workingState === 1 || this.workingState === 2) return true;
    return false;
  }

  created() {
    this.$store.commit("setActiveId", {
      activeId: storeMenus().find(m => m.pageName === "MasterManagementsPage")
        ?.id
    });
    this.setCompanies();
    this.setPrefectures();
    this.setUserGroups();
    this.setStore();
  }

  handleChange(isChecked) {
    this.isRemoved = isChecked;
  }

  addNewGroup() {
    this.userGroups.push({ value: "", errors: [] });
  }

  submit() {
    this.resetError();
    this.validateForm();
    if (this.hasError) return;

    if (!this.isRemoved) {
      this.save();
      return;
    }
    this.display = true;
  }

  hideAlert() {
    this.display = false;
  }

  save() {
    //保存用データ用意
    const closeDate = this.formatDate(this.closeDate.value);
    const storeData = {
      store_id: this.shopId.value,
      store_no: this.shopNumber.value,
      store_name: this.shopName.value,
      prefecture_id: this.pref.value,
      address: this.address.value,
      tel_no: this.tel.value === "" ? null : this.tel.value,
      opening_date: this.formatDate(this.openDate.value),
      closing_date: closeDate === "" ? null : closeDate,
      storegroup_id: this.shopGroup.value,
      usergroup: this.userGroups.map(userGroup => userGroup.value),
      gateway_info: this.gateway.value === "" ? null : this.gateway.value
    };

    //保存
    registerStoreApi(storeData)
      .then(() => {
        const path = getRoutePath("MasterManagementsPage", {
          store_id: this.shopId.value
        });
        this.$router.push(path);
      })
      .catch(e => {
        this.errorMessage = "保存失敗しました。";
        for (let index = 0; index < e.errors.length; ++index) {
          if (
            e.errors[index].message.includes(
              "The same value can not be registered:"
            )
          ) {
            const item = e.errors[index].message.substring(
              e.errors[index].message.indexOf(":") + 2
            );
            switch (item) {
              case "store_no":
                this.addError("shopNumber", "store_no_unique");
                break;
              case "store_name":
                this.addError("shopName", "store_name_unique");
                break;
              case "gateway_info":
                this.addError("gateway", "gateway_unique");
                break;
            }
          }
        }
      });
  }

  isErrorForm(form) {
    return this[form].errors.length > 0;
  }
  isErrorUserGroupForm(index) {
    return this.userGroups[index].errors.length > 0;
  }
  getErrorMessages(form) {
    return this[form].errors;
  }

  validateForm() {
    if (this.corp.value === "") this.addError("corp", "required_select");
    if (this.shopId.value === "") this.addError("shopId", "required_input");
    if (/[^0-9A-Za-z]/.test(this.shopId.value))
      this.addError("shopId", "alphanumeric");
    if (this.shopNumber.value === "")
      this.addError("shopNumber", "required_input");
    if (/[^0-9]/.test(this.shopNumber.value))
      this.addError("shopNumber", "number");
    if (this.shopName.value === "") this.addError("shopName", "required_input");
    if (this.shopGroup.value === "")
      this.addError("shopGroup", "required_select");
    if (this.pref.value === "") this.addError("pref", "required_select");
    if (this.address.value === "") this.addError("address", "required_input");
    if (this.tel.value && /[^0-9]/.test(this.tel.value))
      this.addError("tel", "number");
    if (this.openDate.value === null || this.openDate.value === "") {
      this.addError("openDate", "required_input");
    } else if (!moment.isValid(this.openDate.value))
      this.addError("openDate", "format");
    if (
      this.closeDate.value !== "" &&
      this.closeDate.value !== null &&
      !moment.isValid(this.closeDate.value)
    )
      this.addError("closeDate", "format");
    if (!this.userGroups.some(group => group.value !== "")) {
      this.hasError = true;
      this.userGroups[0].errors = [this.errorMessages.required_select];
    }
    // 2023/05/31 ゲートウェイ情報を必須に変更
    if (this.gateway.value === "") this.addError("gateway", "required_input");
  }
  addError(form, error) {
    let errors = [...this[form].errors];
    errors.push(this.errorMessages[error]);
    this[form].errors = errors;
    this.hasError = true;
  }
  resetError() {
    this.hasError = false;
    const formNames = [
      "corp",
      "shopId",
      "shopNumber",
      "shopGroup",
      "shopName",
      "pref",
      "address",
      "tel",
      "openDate",
      "openDate",
      "closeDate",
      "gateway"
    ];
    formNames.forEach(name => {
      this[name].errors = [];
    });
    let userGroups = [...this.userGroups];
    userGroups.map(group => (group.errors = []));
    this.userGroups = userGroups;
  }

  selectCorp(selected) {
    this.corp.value = selected;
    this.shopGroup.value = "";
    this.setStoregroups(selected);
  }
  inputShopId(input) {
    this.shopId.value = input;
  }
  inputShopNumber(input) {
    this.shopNumber.value = input;
  }
  inputShopName(input) {
    this.shopName.value = input;
  }
  inputShopGroup(input) {
    this.shopGroup.value = input;
  }
  selectPref(selected) {
    this.pref.value = selected;
  }
  inputTel(input) {
    this.tel.value = input;
  }
  inputAddress(input) {
    this.address.value = input;
  }
  inputGateway(input) {
    this.gateway.value = input;
  }
  selectUsergroup(selected, index) {
    let groups = [...this.userGroups];
    groups[index].value = selected;
    this.userGroups = groups;
  }
  changeOpenDate(date) {
    this.openDate.value = date;
  }
  changeCloseDate(date) {
    this.closeDate.value = date;
  }
  formatDate(date): string {
    if (date) {
      const newDate = new Moment("YYYYMMDD", date);
      return newDate.getFormatDate();
    }
    return "";
  }
  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }

  //API
  setCompanies() {
    getCompanyApi().then((resp: GetCompanyResponse[]) => {
      this.companies = resp;
    });
  }

  setStoregroups(companyId?: string, storeGroupId?: string) {
    getStoregroupApi(companyId).then((resp: GetStoregroupResponse[]) => {
      this.storegroups = resp;
      if (storeGroupId) {
        this.shopGroup.value = storeGroupId;
      }
    });
  }

  setPrefectures() {
    getPrefectureApi().then((resp: GetPrefectureResponse[]) => {
      this.prefectures = resp;
    });
  }

  setUserGroups() {
    getUsersgroupsApi().then((resp: GetUsergroupResponse[]) => {
      this.allUserGroups = resp;
    });
  }

  openDialog() {
    this.isConfirmDialogOpen = true;
  }

  closeConfirm() {
    this.isConfirmDialogOpen = false;
  }

  movePage() {
    this.$router.push(
      getRoutePath("MasterManagementsPage", {
        store_id: this.$route.params.store_id
      })
    );
  }

  setStore() {
    getStoresApi(this.$route.params.store_id).then(
      (resp: GetStoresResponse) => {
        this.setStoregroups(resp.company_id, resp.storegroup_id);
        this.corp.value = resp.company_id;
        this.shopId.value = resp.store_id;
        this.shopNumber.value = resp.store_no;
        this.shopName.value = resp.store_name;
        this.shopGroup.value = resp.storegroup_id;
        this.pref.value = resp.prefecture_id;
        this.address.value = resp.address;
        this.tel.value = resp.tel_no;
        this.openDate.value = resp.opening_date;
        this.closeDate.value = resp.closing_date;
        this.gateway.value = resp.gateway_info;
        this.isRemoved = resp.working_state === 2;
        this.workingState = resp.working_state;
        this.userGroups = resp.usergroup.map(usergroup => {
          return { value: usergroup.usergroup_id, errors: [] };
        });
      }
    );
  }
}
